export default {
  journey: {
    get: {
      method: 'post',
      url: '/p/monitoring/journeys'
    },
    getDetail: {
      method: 'get',
      url: '/p/monitoring/journeys/ID'
    },
    setActualTime: {
      method: 'post',
      url: '/p/monitoring/journeys/ID/actual-time'
    },
    file: {
      get: {
        method: 'get',
        url: '/p/monitoring/journeys/ID/files'
      },
      upload: {
        method: 'post',
        url: '/p/monitoring/journeys/ID/files'
      },
      edit: {
        method: 'put',
        url: '/p/monitoring/journeys/ID/files/ID_FILE'
      },
      delete: {
        method: 'delete',
        url: '/p/monitoring/journeys/ID/files/ID_FILE'
      }
    },
    alert: {
      get: {
        method: 'post',
        url: '/p/monitoring/journeys/ID/alerts'
      }
    },
    activities: {
      get: {
        method: 'post',
        url: '/p/monitoring/journeys/ID/activities'
      }
    },
    read: {
      method: 'post',
      url: '/p/monitoring/journeys/ID/read'
    }
  },
  vehicle: {
    get: {
      method: 'post',
      url: '/p/monitoring/vehicles'
    }
  },
  alert: {
    get: {
      method: 'post',
      url: '/p/monitoring/alerts'
    },
    scheduleSkip: {
      method: 'post',
      url: '/p/monitoring/journeys/ID/schedule-alerts/ALERT_ID/skip'
    }
  }
}
